export const injectTypes = {
    projectContext: 'projectContext',
    userContext: 'userContext',
    loadUserContext: 'loadUserContext',
    applyFilters: 'applyFilters',
    refreshProjectContext: 'refreshProjectContext',
    loadAssetGroup: 'loadAssetGroup',
    // ViewProcessing
    startViewProcessing: 'startViewProcessing',
    stopViewProcessing: 'stopViewProcessing',
    withViewProcessing: 'withViewProcessing',
    isProcessingView: 'isProcessingView',
    // Adyen Payment Configuration
    adyenPaymentContext: 'adyenPaymentContext',
    // Project Performance Marketing
    performanceMarketingUserApiKey: 'performanceMarketingUserApiKey',
    performanceMarketingProjectContext: 'performanceMarketingProjectContext',
    modalBox: {
        withModalProcessing: 'withModalProcessing',
    },
    fieldId: 'fieldId',
};